module.exports = __webpack_public_path__ + "media/images/red-pin-ff9274268c2ef5eb06e0eff3980d03c2.png";